import axios from 'axios';
/*
    NOTE: Headers:
    expireResponseWithKey: Se utiliza para expirar los response cachados, simpre y cuando la url coincida con el string enviado como valor;
    notCachedResponse: Se utiliza para no cachar los response de dichas solicitudes.
    persistResponse: Se utiliza para persistir los response sin importar el tiempo de expiración.
*/

const keyCached = "cached-response";
const maxTime = 1000 * 30;

const cached = new Map();

const handleRequest = (req) => {

    if (!req.headers['User-Agent-Front']) {
        req.headers['User-Agent-Front'] = 'Mavi-Tickets';
    }


    if (req.headers.expireResponseWithKey) {
        forceExpireCachedResponse(req.headers.expireResponseWithKey);
        delete req.headers.expireResponseWithKey
    }

    if (req.method.toLowerCase() === "get" && !req.headers.notCachedResponse) {
        const isCached = cached.has(req.url) && typeof cached.get(req.url).response?.data !== "undefined";

        if (isCached && (typeof req.headers.persistResponse !== "undefined" || !isExpired(req.url))) {
            return Promise.reject({ key: keyCached, url: req.url });
        }
    }

    delete req.headers.persistResponse;
    delete req.headers.notCachedResponse;

    return Promise.resolve(req);
}

const handleSuccessResponse = (response) => {

    if (response.config.method.toLowerCase() === "get") {
        saveResponse(response.config.url, response);
    }

    return Promise.resolve(response);
}

const handleFailureOrCachedResponse = (response) => {

    if (typeof response === "object" && response.key === keyCached) {
        const cachedResponse = cached.get(response.url);

        return Promise.resolve(cachedResponse.response);
    } else {

        cached.clear();

        return Promise.reject({ ...response });
    }

}

const isExpired = (url, response) => {

    const cachedResponse = response || cached.get(url);

    const expired = cachedResponse.lastRead < (Date.now() - maxTime);

    if (!cachedResponse.persist && expired) {
        cached.delete(url);
    }

    return expired;
}

const forceExpireCachedResponse = (urlKey) => {

    cached.forEach((_, key) => {
        if (key.indexOf(urlKey) > -1) {
            cached.delete(key);
        }
    });
}

const saveResponse = (key, response, persist) => {
    const cachedResponse = cached.get(key) || {};

    const obj = {
        ...cachedResponse,
        response,
        lastRead: Date.now()
    }

    if (persist) {
        cached.set(key, { ...obj, persist });
    } else {
        cached.set(key, obj);
    }

}

setInterval(() => {
    cached.forEach((value, key) => {
        isExpired(key, value);
    });
}, maxTime);

axios.interceptors.request.use(handleRequest);
axios.interceptors.response.use(handleSuccessResponse, handleFailureOrCachedResponse);
